module.exports = __webpack_public_path__ + "img/chevron-right.35a964d2.svg";